import { Link, Outlet } from "react-router-dom";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { useLang } from "../i18n/LangContext";
import { Flame, ArrowLeft } from "lucide-react";
import { useBranding, logoUrl } from "../contexts/BrandingContext";

export function PublicLayout() {
  const { t } = useLang();
  const { branding } = useBranding();
  return (
    <div className="min-h-screen bg-[#090A0F] text-slate-200 flex flex-col">
      <header className="border-b border-white/5 bg-[#090A0F]/80 backdrop-blur-sm sticky top-0 z-30">
        <div className="mx-auto max-w-6xl px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/login" className="flex items-center gap-2.5 group" data-testid="public-nav-brand">
            {branding?.logo_file_id ? (
              <img src={logoUrl(branding.logo_file_id)} alt="logo" className="h-9 w-9 rounded-lg object-contain bg-white/5 p-0.5" />
            ) : (
              <span className="h-9 w-9 rounded-lg bg-gradient-to-br from-[#FF3B30] to-[#E02E24] flex items-center justify-center shadow-lg shadow-red-900/30 group-hover:shadow-red-900/50 transition-shadow">
                <Flame className="h-5 w-5 text-white" strokeWidth={2.5} />
              </span>
            )}
            <div className="leading-tight">
              <div className="font-[Outfit] font-extrabold text-white tracking-tight text-lg">{branding?.app_name || t("common.appName")}</div>
              <div className="text-[10px] uppercase tracking-[0.15em] text-slate-500">Member · Coach · Admin</div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <Link
              to="/"
              data-testid="public-back-home"
              className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-1.5 text-sm font-medium text-slate-300 hover:text-white hover:bg-white/5 transition"
            >
              <ArrowLeft className="h-4 w-4" />
              {t("common.backToHome") || "Beranda"}
            </Link>
            <LanguageSwitcher />
          </div>
        </div>
      </header>
      <main className="flex-1 grid lg:grid-cols-2">
        <section className="hidden lg:flex flex-col justify-between p-12 xl:p-16 bg-gradient-to-br from-[#0E1018] via-[#10121B] to-[#161923] border-r border-white/5 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#FF3B30]/10 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[#10B981]/10 blur-3xl" />
          <div className="relative">
            <span className="text-xs uppercase tracking-[0.2em] text-[#10B981] font-semibold">Fat Loss Program</span>
            <h1 className="mt-4 font-[Outfit] text-4xl xl:text-5xl font-extrabold text-white tracking-tight leading-tight">
              {t("common.appTagline")}
            </h1>
            <p className="mt-6 text-slate-400 text-lg leading-relaxed max-w-md">
              {t("common.appName")} — bilingual coaching platform. Indonesia · English.
            </p>
          </div>
          <div className="relative grid grid-cols-3 gap-4 max-w-md">
            {["Coach", "Program", "Batch"].map((k) => (
              <div key={k} className="rounded-xl border border-white/5 bg-white/[0.02] p-4">
                <div className="text-2xl font-[Outfit] font-bold text-white">·</div>
                <div className="mt-1 text-xs uppercase tracking-widest text-slate-500">{k}</div>
              </div>
            ))}
          </div>
        </section>
        <section className="flex items-center justify-center px-6 py-12">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </section>
      </main>
    </div>
  );
}
